import dayjs from 'dayjs';
import { joinPath } from './paths.js';
import type { VaultSettings } from './types.js';

export const DEFAULT_DAILY_FOLDER = 'Daily';
export const DEFAULT_DAILY_FORMAT = 'YYYY-MM-DD';
export const DEFAULT_TEMPLATES_FOLDER = 'Templates';
export const DEFAULT_ATTACHMENT_FOLDER = 'attachments';

/**
 * Render {{...}} template variables, Obsidian-style:
 *   {{date}} {{time}} {{title}} {{date:YYYY-MM-DD}} {{time:HH:mm}}
 *   {{date+7d:YYYY-MM-DD}} (offset in d/w/M/y units)
 */
export function renderTemplate(
  template: string,
  opts: { date?: Date; title?: string } = {},
): string {
  const d = dayjs(opts.date ?? new Date());
  return template.replace(
    /\{\{\s*(date|time|title)\s*([+-]\d+[dwMy])?\s*(?::([^}]+))?\}\}/g,
    (_all, kind: string, offset: string | undefined, fmt: string | undefined) => {
      if (kind === 'title') return opts.title ?? '';
      let dd = d;
      if (offset) {
        const n = parseInt(offset.slice(0, -1), 10);
        const unit = offset.slice(-1) as 'd' | 'w' | 'M' | 'y';
        dd = dd.add(n, unit);
      }
      const format = fmt ?? (kind === 'date' ? DEFAULT_DAILY_FORMAT : 'HH:mm');
      return dd.format(format);
    },
  );
}

export function dailyNoteName(settings: VaultSettings, date = new Date()): string {
  return dayjs(date).format(settings.dailyFormat || DEFAULT_DAILY_FORMAT);
}

export function dailyNotePath(settings: VaultSettings, date = new Date()): string {
  return joinPath(
    settings.dailyFolder || DEFAULT_DAILY_FOLDER,
    `${dailyNoteName(settings, date)}.md`,
  );
}
